import { getLAHostnameParts } from '@la/utilities';
import {
  useGetSiteLocationsQuery,
  useGetSiteProgramsQuery,
} from 'redux/services/siteLevelCalendarApi';
import { ActivityWithTeamNames } from 'domains/ActivityForm/openapi-client/models';
import { activityTypes } from '../SiteLevelCalendar';
import {
  isActivityExternal,
  formatDate,
  getFormattedTime,
  getLocationValue,
  getSubLocations,
  isAllDayActivity,
} from './helpers';

type PropType = {
  activity: ActivityWithTeamNames;
};

export const useSiteLevelCalendarDetails = ({ activity }: PropType) => {
  const { programId, homeTeamName, awayTeamName } = activity;
  const { subdomain } = getLAHostnameParts();

  const { data: locations } = useGetSiteLocationsQuery({
    subdomain,
  });

  const { data: sitePrograms } = useGetSiteProgramsQuery({ subdomain });

  const isExternalActivity = isActivityExternal(activity);

  const arrivalTime = activity.arrival
    ? getFormattedTime(activity.arrival)
    : null;
  const startDate = activity.start ? formatDate(activity.start.date) : '';
  const endDate = activity.end ? formatDate(activity.end.date) : '';

  let endTime = '';
  if (!isAllDayActivity(activity) && activity.end) {
    endTime = getFormattedTime(activity.end);
  }

  const subLocations = getSubLocations(locations);
  const locationName = getLocationValue(
    locations || [],
    subLocations,
    activity.locationId,
    activity.subLocationId
  );

  // Left blank for now as it could have sensitive data
  const primaryStaffName = '';
  const awayTeamPrimaryStaffName = '';

  const startTime = activity.start ? getFormattedTime(activity.start) : '';
  let title = activity.title;
  if (!title) {
    if (programId < 1) {
      title = `Sitewide ${activityTypes[activity.type] || 'event'}`;
    } else {
      title = `${homeTeamName} ${activityTypes[activity.type] || 'event'}`;
    }
  }

  const programName = sitePrograms.find((p: any) => p?.id === programId)?.name;

  return {
    activityProgramId: programId,
    activityType: activityTypes[activity.type],
    arrivalTime: arrivalTime,
    teamName: homeTeamName || 'TBD',
    awayTeamName: awayTeamName,
    awayTeamPrimaryStaffName,
    startDate,
    endDate,
    endTime,
    isAllDayActivity: isAllDayActivity(activity),
    isExternalActivity,
    locationName,
    notes: activity.notes,
    primaryStaffName,
    programName,
    startTime,
    title,
    // Not retrieved at the moment
    isAwayTeamExternal: false,
    isHomeTeamExternal: false,
  };
};
